import { render } from "./StatusChip.vue?vue&type=template&id=03f826e1&scoped=true"
import script from "./StatusChip.vue?vue&type=script&lang=js"
export * from "./StatusChip.vue?vue&type=script&lang=js"

import "./StatusChip.vue?vue&type=style&index=0&id=03f826e1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03f826e1"]])

export default __exports__